import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Spinner } from '@ingrid/luterkort-react';

import { TrackingEventEnum } from '~src/main/hooks/useTracking';
import { CreatePage } from '~src/pages/shipment/create/page';
import { useShipmentHydrateMutation } from '~src/pages/shipment/mutations';
import { ShipmentUpsert } from '~src/pages/shipment/types';

export function OrderCreateShipmentPage() {
  const [shipment, setShipment] = useState<ShipmentUpsert>();

  const hydrateMutation = useShipmentHydrateMutation();
  const { orderId } = useParams();

  useEffect(() => {
    async function init() {
      setShipment(await hydrateMutation.mutateAsync({ tos: { id: orderId } }));
    }

    void (async () => {
      await init();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (hydrateMutation.isIdle || hydrateMutation.isPending) {
    return <Spinner />;
  }

  return (
    <CreatePage
      onSuccessEvent={TrackingEventEnum.ShipmentCreateFromTosCompleted}
      onErrorEvent={TrackingEventEnum.ShipmentCreateFromTosFailed}
      onInitEvent={TrackingEventEnum.ShipmentCreateFromTosStart}
      error={hydrateMutation.error?.message}
      shipment={shipment}
    />
  );
}
